import actionTypes from './actionTypes';
import { trackEvent } from './track';
import { getDocsStateLanguage } from './utilities';

export const trackDocsEvent = (actionType, metadata) => {
  trackEvent({
    event: 'DOCS_EVENT',
    payload: {
      actionType,
      lang: getDocsStateLanguage(),
      beta: false,
      ...metadata,
    },
  });
};

export const setupDocsPathListener = () => {
  // only match on /docs/* urls
  if (window.location.pathname.match(/\/docs*/)) {
    // Listen to navigation events through # changes scoped to a single page.
    // Page <> Page transitions will automatically be tracked through
    window.addEventListener(
      // Note: this functionality only works when navigating using browser
      // navigation and not when navigating using the docs sidebar.
      'hashchange',
      function (event) {
        const hash = new URL(event.newURL).hash;
        const previousHash = new URL(event.oldURL).hash;

        trackDocsEvent(actionTypes.DOCS_ANCHOR_CLICK, {
          previousHash,
          hash,
        });
      },
      false,
    );
  }
};

export default {
  trackDocsEvent,
  setupDocsPathListener,
};
